import { Context } from "@microsoft/teams-js";
import { BrowserStorageKey } from "../constant/storage";

class AppSetting {
    teamContext?: Context | null;
    constructor() {
        this.teamContext = null;
    }
    public setConfig(config: Context) {
        this.teamContext = config;
    }
    public isAppConfigured() {
        if(this.teamContext) {
            return this.teamContext.frameContext !== 'settings';
        }
        
    }
}
const appSetting = new AppSetting();
export default appSetting;